import Swal from 'sweetalert2';

import { BondInsuranceForGetBondInsurancesResponseDTO } from '../../../dtos/bond-insurance-list/get-bond-insurances-response.dto';
import { maskCpf, maskCnpj, maskPhoneNumber } from '../../../services/masks';
import { CreateChargePrefill } from '../../standalone-charges/types';
import './setupChargeShortcut.css';

export const buildSetupChargePrefill = (
  bondInsurance: BondInsuranceForGetBondInsurancesResponseDTO
): CreateChargePrefill => {
  const bondInsuranceData = bondInsurance as any;
  const naturalTenant =
    bondInsuranceData.natural_tenant || bondInsuranceData.naturalTenant;
  const legalTenant = bondInsuranceData.legal_tenant || bondInsuranceData.legalTenant;
  const isNaturalTenant = Boolean(naturalTenant);

  const document = isNaturalTenant
    ? naturalTenant.main_tenant_cpf ||
      naturalTenant.mainTenantCpf ||
      naturalTenant.main_tenant_document ||
      naturalTenant.mainTenantDocument ||
      ''
    : legalTenant?.document || '';
  const phone = isNaturalTenant
    ? naturalTenant.main_tenant_phone || naturalTenant.mainTenantPhone || ''
    : legalTenant?.phone || legalTenant?.contact_phone || legalTenant?.contactPhone || '';

  return {
    estateId: bondInsurance.estate?.id || '',
    payerType: isNaturalTenant ? 'individual' : 'company',
    payerName: isNaturalTenant
      ? naturalTenant.main_tenant_name || naturalTenant.mainTenantName || ''
      : legalTenant?.company || '',
    payerCpf: isNaturalTenant ? maskCpf(document) : maskCnpj(document),
    payerEmail: '',
    payerPhone: maskPhoneNumber(phone)
  };
};

export const showSetupChargeRedirect = async (
  prefill: CreateChargePrefill,
  redirect: (prefill: CreateChargePrefill) => void,
  closeHireModal?: () => void
) => {
  closeHireModal?.();
  await new Promise(resolve => window.setTimeout(resolve, 500));

  await Swal.fire({
    html: `
      <div class="setup-charge-success">
        <div class="setup-charge-success__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="m5.5 12.4 4.2 4.2L18.8 7.5" />
          </svg>
        </div>
        <div class="setup-charge-success__title">
          <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path d="M6 3.75h8l4 4v12.5H6z" />
            <path d="M14 3.75v4h4" />
            <path d="m8.5 13.5 2 2 4.5-4.5" />
          </svg>
          <span>Contratação realizada</span>
        </div>
        <div class="setup-charge-success__message">
          Redirecionando para o envio de Cobranças...
        </div>
      </div>
    `,
    width: 560,
    padding: '30px 32px 22px',
    background: '#FFFFFF',
    backdrop: 'rgba(0, 0, 0, 0.34)',
    customClass: {
      popup: 'setup-charge-success-popup'
    },
    showConfirmButton: false,
    timer: 1800,
    allowOutsideClick: false,
    allowEscapeKey: false
  });
  redirect(prefill);
};
